module.exports = __webpack_public_path__ + "media/images/home/ic_note-819a673a76c83b9673cf1edf43ae79ef.svg";